import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react"; import React, { useEffect, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { useDebounce } from '../../../../../hooks/useDebounce';

import { CustomButton } from '../../../../../components/customButton/CustomButton';
import { CustomDialog } from '../../../../../components/customDialog/CustomDialog';
import { Autocomplete, Box, CircularProgress, InputAdornment, TextField } from '@mui/material';
import { generateColumnsDefaultConfiguration } from '../../../../../components/dataGrid/columnHelpers';
import GrillaVacia from '../../../../../assets/images/grilla-vacia-resumen-ingreso.svg';
import DataGridGenerico from '../../../../../components/dataGrid/DataGridGenerico';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import SearchIcon from '@mui/icons-material/Search';
import { RenderInputByTypeMobile } from '../../../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { getStringQueryCombosRI } from '../../../../../data/graphQL/queries/ResumenIngreso/getAllCombosRI';
import { GET_INSUMOS } from '../../../../../data/graphQL/queries/ResumenIngreso/getAllInsumos';
import { GET_INDICACIONES_BY_PANTALLA } from '../../../../../data/graphQL/queries/ResumenIngreso/getIndicacionesRIByPantalla';
import { CREATE_INDICACION } from '../../../../../data/graphQL/mutations/ResumenIngreso/CreateIndicacionRI';
import { REMOVE_INDICACION } from '../../../../../data/graphQL/mutations/ResumenIngreso/removeIndicacionRI';
import { adaptInsumosDetalladosArray } from '../../../../../adapters/resumenIngreso/insumosDetalladosAdapter';
import { adaptCombosRIArray } from '../../../../../adapters/resumenIngreso/combosRIAdapter';
import { adaptIndicacionesDetalladasArray } from '../../../../../adapters/resumenIngreso/indicacionesDetalladasAdapter';
import { use } from 'i18next';

export const IndicacionDetalladaInput = ({ idPantallaRI, idDatosGeneralesRI, setChildrenAction, edit }) => {

  const combosToRequest = [
    { name: 'intervalo', comboName: 'Intervalo CP' },
    { name: 'unidadTiempo', comboName: 'Unidad de Tiempo CP' },
    { name: 'viaAdministracion', comboName: 'Via de Administración ' }];


  const columns = generateColumnsDefaultConfiguration([
    {
      field: 'action',
      headerName: '',
      flex: 0.03,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <DeleteOutlineIcon className='edit-icon' onClick={() => edit ? deleteIndicacion(row) : null} />);

      }
    },
    {
      headerName: 'Medicamento',
      field: 'nombreInsumo',
      flex: 0.57
    },
    {
      headerName: 'Presentación',
      field: 'presentacion',
      flex: 0.25

    },
    {
      headerName: 'Dosis',
      field: 'cantidadDiaria',
      flex: 0.2
    }]
  );

  const [indicaciones, setIndicaciones] = useState([]);
  const [openformModal, setOpenformModal] = useState(false);
  const [productoSelected, setProductoSelected] = useState({});
  const [presentacion, setPresentacion] = useState('');
  const [indicacion, setIndicacion] = useState({});
  const [combosRI, setCombosRI] = useState();

  const { data: combosData } = useQuery(getStringQueryCombosRI(combosToRequest), {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!combosData) return;

    const combosParse = adaptCombosRIArray(combosData);
    const combosMapped = {
      ...combosParse,
      unidadTiempo: combosParse.unidadTiempo.map((e) => { return { label: e.displayName, value: e.id }; })
    };
    setCombosRI(combosMapped);
  }, [combosData]);

  const [
    insumos,
    filterStatus,
    insumosLoading,
    setFilterStatus] =
    useGetInsumos(idDatosGeneralesRI);

  const { refetch: refetchIndicaciones, data: indicacionesData } = useQuery(GET_INDICACIONES_BY_PANTALLA, {
    fetchPolicy: 'no-cache',
    variables: { idPantallaRI, idDatosGeneralesRI },
  });

  useEffect(() => {
    if (!indicacionesData) return;

    setIndicaciones(adaptIndicacionesDetalladasArray(indicacionesData));
  }, [indicacionesData]);

  const [createIndicacion] = useMutation(CREATE_INDICACION);
  const [removeIndicacion] = useMutation(REMOVE_INDICACION);

  const handleOpenFormModal = () => setOpenformModal(true);

  const handleCloseFormModal = () => {
    setOpenformModal(false);
    setIndicacion({});
    setPresentacion('');
  };

  const handleChange = (value) => {
    setProductoSelected(value);
  };

  useEffect(() => {
    const presentacionAux = productoSelected?.presentacionGenerica ? '' : `${productoSelected?.presentacionGenerica} ${productoSelected?.presentacion} ${productoSelected?.idUnidadNavigation?.alias}`;
    setPresentacion(presentacionAux);
  }, [productoSelected]);

  const handleChangeIndicacion = (name, value) => {
    setIndicacion((prevDatos) => { return { ...prevDatos, [name]: value }; });
  };

  useEffect(() => {
    if (!indicaciones.length) return setChildrenAction(null);

    setChildrenAction(() =>
      <CustomButton
        onClick={handleOpenFormModal}
        disabled={!edit}
        size='small'
        variant='outlined'>

        Agregar
      </CustomButton>
    );

  }, [indicaciones]);

  const deleteIndicacion = async (indicacion) => {
    try {
      await removeIndicacion({
        variables: {
          idIndicacionRI: indicacion?.idIndicacionRI
        }
      });
      const { data: indicacionesData } = await refetchIndicaciones();
      setIndicaciones(adaptIndicacionesDetalladasArray(indicacionesData));
    } catch (err) {
      console.log(err);
    }
  };


  const onSubmit = async () => {
    if (!edit) return;
    try {
      await createIndicacion({
        variables: {
          idDatosGeneralesRI,
          idInsumo: productoSelected.id,
          idPantallaRI,
          idComboRIValorViaAdministracion: parseInt(indicacion['viaAdministracion']),
          idComboRIValorUnidadtiempo: parseInt(indicacion['unidadTiempo']),
          idComboRIValorIntervalo: parseInt(indicacion['intervalo']),
          cantidadDiaria: parseFloat(indicacion['dosis'])
        }
      });
      const { data: indicacionesData } = await refetchIndicaciones();
      setIndicaciones(adaptIndicacionesDetalladasArray(indicacionesData));
      handleCloseFormModal();
      toast.success('Indicación cargada con éxito');
    } catch (err) {
      toast.error('Ocurrió un error al cargar la indicación');
    }
  };

  return (
    <>

      {!indicaciones?.length && <div className='resumen-ingreso-grilla-vacia'>
        <div className='svg-clientes-grilla-vacia'>
          <img src={GrillaVacia} width='100%'></img>
        </div>
        <label>No se ha agregado ninguna indicación</label>
        <CustomButton
          onClick={handleOpenFormModal}
          size='small'>

          Agregar
        </CustomButton>
      </div>}
      {!!indicaciones.length &&
        <Box sx={{ width: '100%' }}>
          <DataGridGenerico
            columns={columns}
            rows={indicaciones}
            toolbar={false}
            hideFooter />

        </Box>
      }
      <CustomDialog
        maxWidth='md'
        fullWidth
        onCancel={handleCloseFormModal}
        open={openformModal}
        cancelText='Cerrar'
        onAccept={onSubmit}
        acceptDisabled={false}
        acceptText='Agregar'
        title='Indicaciones'>

        <Autocomplete
          options={insumos}
          disableClearable
          noOptionsText={filterStatus ? 'No hay coincidencias' : 'Escriba para buscar'}
          onChange={(_, newValue) => handleChange(newValue)}
          onInputChange={(e) => setFilterStatus(e.target.value)}
          renderOption={(props, option) => {
            return (
              <Box {...props} key={option.id}>
                {option?.label}
              </Box>);

          }}
          renderInput={(params) =>
            <TextField
              {...params}
              sx={{ '.MuiOutlinedInput-root': { paddingRight: '15px !important' } }}
              label='Buscador medicamentos'
              margin='none'
              size='small'
              InputProps={{
                ...params.InputProps,
                endAdornment:
                  <InputAdornment position='end'>
                    {insumosLoading ?
                      <CircularProgress color='inherit' size={20} /> :
                      <SearchIcon className='search-icon' />}
                  </InputAdornment>

              }} />
          } />

        <RenderInputByTypeMobile
          grided
          handleChange={(name, value) => handleChangeIndicacion(name, value)}
          input={{
            name: 'presentacion',
            displayName: 'Presentacion',
            type: 'string',
            required: true,
            disabled: true
          }}
          value={productoSelected['presentacion']} />

        <RenderInputByTypeMobile
          grided
          handleChange={(name, value) => handleChangeIndicacion(name, value)}
          input={{
            name: 'dosis',
            displayName: 'Dosis',
            type: 'float',
            required: true
          }}
          value={indicacion['dosis']} />

        <RenderInputByTypeMobile
          grided
          handleChange={(name, value) => handleChangeIndicacion(name, value)}
          input={{
            name: 'intervalo',
            displayName: 'Intervalo',
            type: 'select',
            required: true,
            options: combosRI?.intervalo || []
          }}
          value={indicacion['intervalo']} />

        <RenderInputByTypeMobile
          grided
          row
          handleChange={(name, value) => handleChangeIndicacion(name, value)}
          input={{
            name: 'unidadTiempo',
            displayName: 'Unidad de Tiempo',
            type: 'multiple_boolean',
            required: true,
            options: combosRI?.unidadTiempo || []
          }}
          value={indicacion['unidadTiempo']} />

        <RenderInputByTypeMobile
          grided
          handleChange={(name, value) => handleChangeIndicacion(name, value)}
          input={{
            name: 'viaAdministracion',
            displayName: 'Via de Administración',
            type: 'select',
            required: true,
            options: combosRI?.viaAdministracion || []
          }}
          value={indicacion['viaAdministracion']} />

      </CustomDialog>
    </>);

};

const useGetInsumos = (idDatosGeneralesRI) => {

  const [insumos, setInsumos] = useState([]);

  const [filterStatus, setFilterStatus] = useState('');
  const debouncedFilterValue = useDebounce(filterStatus, 1000);

  const [getInsumos, { loading: insumosLoading, data: insumosResults }] = useLazyQuery(GET_INSUMOS);

  useEffect(() => {
    if (!insumosResults) return;

    setInsumos(insumosResults);
  }, [insumosResults]);

  useEffect(() => {
    if (!insumosLoading && !!debouncedFilterValue?.trim()) {
      getInsumos({
        variables: {
          idDatosGenerales: idDatosGeneralesRI,
          where: { descripcion: { contains: debouncedFilterValue } }
        }
      });
    }
  }, [debouncedFilterValue]);

  return [
    adaptInsumosDetalladosArray(insumos) || [],
    filterStatus,
    insumosLoading,
    setFilterStatus];


};